<template>
  <div class="fixed inset-0 z-50">
    <file-detail-manager :file-id="route.params.file_id" :file-context="fileContext" />
  </div>
</template>

<script setup>
  definePageMeta({
    isLightbox: true
  });

  const route = useRoute();
  const {share_token: shareToken, user_id_or_slug: userId} = route.params;
  const {isAuthenticated} = useSessionStore();

  const fileContext = {
    contextType: FILE_CONTEXTS.file,
    shareToken,
    userId,
    query: route.query
  };

  if (route.query.exitToRoute) {
    provide('exitToRoute', route.query.exitToRoute);
  }

  const file = useFilesStore().file;
  onMounted(() => {
    //set up the signup cookie which allows us to link users to the sharer during signup.
    if (!isAuthenticated && shareToken) {
      useCommonModals().openSignupFromShareModal({
        referrer: file.user,
        referralSource: 'share-file',
        referralContext: 'share'
      });
    }
  });
</script>
